import {useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {viewService} from "../../../../../services/viewService";
import {ViewFileTablesTabs} from "./ViewFileTablesTabs";
import {Spacer} from "../../../../../components/DesignSystem/Spacer/Spacer";
import {DownloadDropDown} from "../../../ai-assistant/DownloadDropDown";
import {Row, Col, Result, Button, Flex, Dropdown, Space} from "antd";
import {downloadFile} from "../../../../../utils/download.utils";
import {getErrorFromResponse} from "../../../../../utils/error.utils";
import {PublicContent} from "../../../../../components/apps/public/PublicContent";
import {ViewExplainModal} from "../../../ai-assistant/modal/ViewExplainModal";
import {VirtualTable} from "../../../../../components/VirtualTable/VirtualTable";
import {getRestApiSort} from "../../../../../utils/sort.utils";
import SettingOutlined from "@ant-design/icons/lib/icons/SettingOutlined";
import {ViewFilePreviewColumnsPreferences} from "./ViewFilePreviewColumnsPreferences";
import {DownloadOutlined, SaveOutlined} from "@ant-design/icons";
import {ExportDialog} from "./export/ExportDialog";
import {SaveDialog} from "./save/SaveDialog";


export const ViewFilePreviewPage = ({}) => {


    const [preview, setPreview] = React.useState(null);
    const [previewTable, setPreviewTable] = React.useState(null);
    const [loading, setLoading] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [tableSort, setTableSort] = useState(null);
    const [showExplainModal, setShowExplainModal] = useState(false);
    const [columns, setColumns] = useState([]);
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [showPreferences, setShowPreferences] = useState(false);
    const [showExportDialog, setShowExportDialog] = useState(false);
    const [showSaveDialog, setShowSaveDialog] = useState(false);

    const defaultPage = 1;
    const defaultSize = 400;

    let {fileId} = useParams();


    useEffect(() => {

        setLoading(true);
        setError(null);

        viewService.fetchPreview(fileId).then(response => {
            setPreview(response.data);

            const tableName = response.data.tables[0].tableName;

            setPreviewTable(tableName);
            convertColumns(response.data.tables[0].columns);
            setSelectedColumns(response.data.tables[0].columns);
            fetchData(fileId, tableName, defaultPage, defaultSize, undefined);
        }).finally(() => {
            setLoading(false);
        }).catch(error => {
            setError(getErrorFromResponse(error));
        });

    }, [fileId]);

    const handleTableChange = (key) => {
        setPreviewTable(key);
        convertColumns(preview.tables.find(table => table.tableName === key).columns);
        fetchData(fileId, key, defaultPage, defaultPage, undefined);
    }

    const convertColumns = (columns) => {

        setColumns(columns.map((item, index) => {
            return {
                title: item.name,
                dataIndex: item.name,
                key: index,
                ellipsis: true,
                sorter: true,
                minWidth: 100,
                onCell: () => ({
                    style: {
                        whiteSpace: 'nowrap',
                        width: 'max-content',
                    },
                }),
            }
        }));

    };

    const fetchData = (fileId, previewTable, page, size, sort) => {
        setTableSort(sort);
        viewService.fetchData(fileId, previewTable, page, 400, "select * from " + previewTable, sort).then(response => {
            setData(response.data.page.content);
            setDataLoaded(true);
        })
    }

    const handleDownload = (format, filename) => {

        const columnNames = columns.filter(column => column.hidden === false).map(column => column.title);

        setShowExportDialog(false);

        viewService.downloadData(fileId, previewTable, "select * from " + previewTable, tableSort, format, columnNames).then(response => {
            downloadFile(response.data, filename, "octet/stream");
        })

    }

    const handleSave = (format, filename) => {

        const columnNames = columns.filter(column => column.hidden === false).map(column => column.title);

        viewService.saveData(fileId, previewTable, "select * from " + previewTable, tableSort, format, filename, columnNames).then(response => {
            console.log("Data saved successfully", response);
        }).catch(error => {
            console.error("Error saving data:", error);
            setError(getErrorFromResponse(error));
        }).finally(() => {
            setShowSaveDialog(false);
            console.log("Save operation completed");
        });

    }

    const onAsk = () => {
        setShowExplainModal(true);
    }

    const handleCloseExplain = () => {
        setShowExplainModal(false);
    }

    const handleLoadMore = () => {
        if (loading) {
            return;
        }
        setLoading(true);
        viewService.fetchData(fileId, previewTable, currentPage + 1, defaultSize, "select * from " + previewTable, tableSort).then(response => {
            setData([...data, ...response.data.page.content]);
            setDataLoaded(response.data.page.content.length > 0);
            setCurrentPage(currentPage + 1);
        }).finally(() => {
            setLoading(false);
        });
    }

    const handleOnChange = (pagination, filters, sorter) => {
        const sort = getRestApiSort(sorter);
        fetchData(fileId, previewTable, defaultPage, defaultSize, sort);
        setTableSort(sort);
    }

    const handleColumnsChange = (changedColumns) => {

        const newColumns = changedColumns.map(column => {
            const existingColumn = columns.find(item => item.title === column.name);
            return {
                ...existingColumn,
                hidden: !column.visible,
            };
        });

        setColumns(newColumns);

        setShowPreferences(false);

    }

    console.log(preview)

    return <div>
        {showExplainModal && <ViewExplainModal tableName={previewTable} fileId={fileId} onClose={handleCloseExplain}/>}


        <Row style={{paddingTop: "10px", paddingLeft: "10px", paddingRight: "10px"}}>
            <Col span={16}>
                <h5>Data Viewer - {preview && preview.name}</h5>
            </Col>
            <Col span={8} style={{textAlign: "right"}}>
                <Space>
                    <Button color="purple" variant="solid" onClick={onAsk}>
                        ✨ AI Explain data
                    </Button>
                    <Button icon={<SaveOutlined/>} onClick={() => setShowSaveDialog(true)}/>
                    <Button icon={<DownloadOutlined/>} title={"Export"} onClick={() => setShowExportDialog(true)}/>
                    <Button icon={<SettingOutlined/>} onClick={() => setShowPreferences(true)}/>
                </Space>
            </Col>
        </Row>
        <Spacer border={true}/>
        {selectedColumns && <ViewFilePreviewColumnsPreferences columns={selectedColumns}
                                                               onOk={handleColumnsChange}
                                                               onCancel={() => setShowPreferences(false)}
                                                               visible={showPreferences}/>}
        {preview && showSaveDialog && <SaveDialog visible={showSaveDialog} onOk={handleSave}
                      onCancel={() => setShowSaveDialog(false)} filename={preview.name} format={preview.format} />}
        {preview && showExportDialog && <ExportDialog visible={showExportDialog} onOk={handleDownload}
                      onCancel={() => setShowExportDialog(false)} filename={preview.name} format={preview.format} />}
        {preview && preview.tables.length > 1 &&
            <ViewFileTablesTabs tables={preview.tables} onChange={handleTableChange} selectedTab={previewTable}/>}
        {columns && <VirtualTable columns={columns} data={data} onLoadMore={handleLoadMore} onChange={handleOnChange}/>}
        {error && <PublicContent width={"800px"}><Result
            status={"error"} title="Failed to load file preview."
            subTitle={"The file is the wrong format or the file is corrupted."}
        /></PublicContent>}
    </div>

}